module.exports = __webpack_public_path__ + "img/left-ad-3.1f062268.png";